export function formatAddress(addL1: string, addL2: string, city: string, state: string, zip: string, country: string) {
  const addr = [];
  addr.push(addL1 ? `${addL1}\n` : '');
  addr.push(addL2 ? `${addL2}\n` : '');
  addr.push(`${city}, ${state} ${zip}, ${country}`);
  return addr.join('');
}
